import React, { Component } from 'react'
import './Logo.css'
import FlipCard from '../FlipCard/FlipCard'
import { toTime } from '../../../shared/utitlity'

class Logo extends Component {

    state = {
        activeId: null,
    }

    flipHandler = (id) => {
        this.setState(prevState => {
            if (prevState.activeId === id) {
                return {
                    activeId: null
                }
            }
            else {
                return {
                    activeId: id
                }
            }
        })
    }

    playNow = (event) => {
        event.stopPropagation();
        this.setState({
            activeId: "c4"
        })
    }
    render() {
        return !this.props.isVisible ? (<div className="logo" >
            <p className="info">
                Click the {this.props.content[3]} to get started.
        </p>
            {localStorage.getItem('flipped') === 'false' ?
                <FlipCard clicked={this.flipHandler} active={this.state.activeId === "c1"}
                    left id="c1" front={this.props.content[0]}>
                    <h2>Figures:</h2>
                    Looks like you haven't FLIPped yet.
                    <div className="a" onClick={this.playNow}>Play now</div>
                </FlipCard> :
                <FlipCard clicked={this.flipHandler} active={this.state.activeId === "c1"}
                    left id="c1" front={this.props.content[0]}>
                    <h2>Figures: <span>
                        <b>{parseInt(localStorage.getItem('flip_won'))}</b><i>Won</i>
                        <b>{parseInt(localStorage.getItem('flip_lost'))}</b><i>Lost</i>
                        <b>{localStorage.getItem('flip_abandoned')}</b><i>Abandoned</i></span>
                    </h2>
                    <ul>
                        <li><b>Best Casual:</b> <span>{toTime(localStorage.getItem('flip_casual'))}</span></li>
                        <li><b>Best Medium:</b> <span>{toTime(localStorage.getItem('flip_medium'))}</span></li>
                        <li><b>Best Hard:</b> <span>{toTime(localStorage.getItem('flip_hard'))}</span></li>
                    </ul>
                    <ul>
                        <li><b>Total Flips:</b> <span>{parseInt((parseInt(localStorage.getItem('flip_matched')) + parseInt(localStorage.getItem('flip_wrong'))) * 2)}</span></li>
                        <li><b>Matched Flips:</b> <span>{localStorage.getItem('flip_matched')}</span></li>
                        <li><b>Wrong Flips:</b> <span>{localStorage.getItem('flip_wrong')}</span></li>
                    </ul>
                </FlipCard>
            }
            <FlipCard clicked={this.flipHandler} active={this.state.activeId === "c2"} id="c2" front={this.props.content[1]}>
                L
        </FlipCard>
            <FlipCard clicked={this.flipHandler} active={this.state.activeId === "c3"} left id="c3" front={this.props.content[2]}>
                <h2>Instructions</h2>
                <p>Press [p] to pause, or [ESC] to abandon game.</p>
                <p>Flip is a timed card memory game. Click the green cards to see what symbol they uncover and try to find the matching symbol underneath the other cards.</p>
                <p>Uncover two matching symbols at once to eliminate them from the game.</p>
                <p>Eliminate all cards as fast as you can to win the game. Have fun FLIPing!</p>
            </FlipCard>
            <FlipCard clicked={this.flipHandler} active={this.state.activeId === "c4"} id="c4" front={this.props.content[3]}>
                <div className="a" onClick={(event) => {
                    this.setState({ activeId: null });
                    this.props.clicked(event, "casual")
                }} >Casual</div>
                <div className="a" onClick={(event) => { this.props.clicked(event, "medium") }}>Medium</div>
                <div className="a" onClick={(event) => { this.props.clicked(event, "hard") }}>Hard</div>
            </FlipCard>
            <p className="info">
                Flip should work best in Google Chrome, decent in Firefox, IE10 and Opera;
  </p>
        </div>
        ) : null

    }
}
export default Logo;